/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
} from './ContactType';

/**
 * A payload to update client contact in a client organization
 * @export
 * @interface UpdateClientContact
 */
export interface UpdateClientContact {
    /**
     * 
     * @type {ContactType}
     * @memberof UpdateClientContact
     */
    contactType?: ContactType;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UpdateClientContact
     */
    metadataSchemaRID?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateClientContact
     */
    metadata?: object;
}

/**
 * Check if a given object implements the UpdateClientContact interface.
 */
export function instanceOfUpdateClientContact(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateClientContactFromJSON(json: any): UpdateClientContact {
    return UpdateClientContactFromJSONTyped(json, false);
}

export function UpdateClientContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactType': !exists(json, 'contactType') ? undefined : ContactTypeFromJSON(json['contactType']),
        'metadataSchemaRID': !exists(json, 'metadataSchemaRID') ? undefined : json['metadataSchemaRID'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function UpdateClientContactToJSON(value?: UpdateClientContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactType': ContactTypeToJSON(value.contactType),
        'metadataSchemaRID': value.metadataSchemaRID,
        'metadata': value.metadata,
    };
}

